import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { VnextReleaseFeatures } from '../../../shared/models/vnext-release-features.model';
import { VnextReleaseFeaturesService } from '../../../shared/services/vnext-release-features.service';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-vnext-release-features',
    templateUrl: './vnext-release-features.component.html',
    styleUrls: ['./vnext-release-features.component.scss'],
    standalone: false
})
export class VnextReleaseFeaturesComponent implements OnInit {
    // Properties.
    private releaseFeatures: VnextReleaseFeatures = null;

    // Constructor.

    public constructor(private releaseFeaturesService: VnextReleaseFeaturesService,
        private readonly titleService: Title) {
        return;
    }

    // Life cycle methods.
    public ngOnInit(): void {
        // <!--<div [innerHTML]="this.NewReleaseFeaturesHtml | safe: 'html'"></div>-->

        this.releaseFeaturesService.getCurrentReleaseFeatures().then(response => {
            this.releaseFeatures = response;
        });

        this.titleService.setTitle(environment.sitename + ' - New Features');

        return;
    }

    // Method called by my HTML code.
    public get NewReleaseFeaturesRetrieved(): boolean {
        return this.releaseFeatures != null;
    }
    public get NewReleaseFeaturesHtml(): string {
        let enteredHtml: string = (this.releaseFeatures != null ? this.releaseFeatures.newFeatures : null);
        let html: string =
            '<html>' +
            '  <body>' +
            (enteredHtml != null ? enteredHtml : '    <p>This section is under construction.</p>') +
            '  </body>' +
            '</html>';
        return html;
    }
    public get ComingSoonReleaseFeaturesHtml(): string {
        let html: string = (this.releaseFeatures != null ? this.releaseFeatures.comingSoonFeatures : null);
        if (html == null) {
            html =
                '<html>' +
                '  <body>' +
                ((this.releaseFeatures == null) || (this.releaseFeatures.newFeatures == null) ?
                '    <p>This section is also under construction.</p>' :
                '    <p>This section is under construction.</p>') +
                '  </body>' +
                '</html>';
        }
        return html;
    }

}
